<template>
    <div>
        <!-- MAIN IMAGE -->
        <section>
            <v-layout column align-center justify-center class="white--text">
                <img src="../assets/img/oblo/corridoio 4.jpeg" alt="" style="object-fit: cover" height="600px" width="100%">
            </v-layout>
        </section>

        <!-- INTRO -->
        <section>
            <v-layout row wrap align-center>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="pa-5">
                    <p style="font-size: xx-large; font-weight: 500">{{$t("home.rooms")}}</p>
                    <p class="sub-intro">
                        {{$t("rooms.intro")}}
                    </p>
                </v-flex>
            </v-layout>
        </section>

        <!-- AMMIRAGLIO ROOM -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6>
                    <img :src="getImageUrl('img/ammiraglio/ammiraglio 6.jpeg')" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("rooms.ammiraglio.name")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("rooms.ammiraglio.desc")}}
                            </p>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn class="success mt-5" dark large to="/room/ammiraglio">
                                {{$t("home.more")}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>
        <!-- MOZZO ROOM -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("rooms.mozzo.name")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("rooms.mozzo.desc")}}
                            </p>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn class="success mt-5" dark large to="/room/mozzo">
                                {{$t("home.more")}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2>
                    <img :src="getImageUrl('img/mozzo/mozzo 3.jpeg')" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section>
        <!-- NOSTROMO ROOM -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg1>
                    <img :src="getImageUrl('img/nostromo/nostromo 3.jpeg')" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md2 order-lg2>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("rooms.nostromo.name")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("rooms.nostromo.desc")}}
                            </p>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn class="success mt-5" dark large to="/room/nostromo">
                                {{$t("home.more")}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>
        <!-- CAPITANO ROOM -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("rooms.capitano.name")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("rooms.capitano.desc")}}
                            </p>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn class="success mt-5" dark large to="/room/capitano">
                                {{$t("home.more")}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2>
                    <img :src="getImageUrl('img/capitano/capitano 1.jpeg')" alt="" width="100%" height="100%">
                </v-flex>
            </v-layout>
        </section>

        <section>
            <v-layout row wrap align-center>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="amber pa-5 success--text">
                    <p style="font-size: xx-large; font-weight: 350; font-style: italic;">
                        {{$t("rooms.breakfast")}}
                    </p>
                    <p class="sub-intro" style="font-style: italic;">
                        {{$t("rooms.breakfast_details")}}
                    </p>
                    <p>
                        <v-btn class="success mt-5" dark large to="/breakfast">
                            {{$t("home.more")}}
                        </v-btn>
                    </p>
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods: {
      getImageUrl: function(image){
        return require(`../assets/${image}`);
      }
    }
}
</script>

<style scoped>
    .sub-intro{
        font-size: large;
        font-weight: 400;
    }

    .my-headline{
        font-size: xx-large;
        font-weight: 300;
        font-style: italic;
    }

    .mybg{
        background-color: var(--v-primary-base);
    }

    .my-fit{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 500px;
    }
</style>